import { EnvironmentSensorType } from '@mgh-app/component-library';

export type Things = Thing[];

export type ToggleState = 'ON' | 'OFF';

export interface Thing {
  createdAt: string;
  roomId: string;
  id: string;
  identifier: string;
  image: string;
  isParent: number;
  name: string;
  parentId: string;
  position: number;
  status: number;
  thingType: string;
  updatedAt: string;
}

export enum ThingType {
  Individual = 'individual',
  Group = 'group',
  GroupParent = 'group_parent',
}

export enum ThingIdentifier {
  DMX = 'DMX',
  Curtains = 'CURTAIN',
  Blinds = 'BLIND',
  Temperature = 'TEMPERATURE',
  AirQualitySensors = 'AIR_QUALITY_SENSORS',
}

export interface Light {
  lightIds: string[];
  brightness?: number;
  power: ToggleState;
}

export interface LightingPreset {
  name: string;
  lights: { [key: string]: number };
}

export interface AirQualitySensor {
  type: EnvironmentSensorType;
  value?: number | undefined;
  label?: string;
}

export interface AllAirQualitySensors {
  timestamp: number;
  sensors: { [key: string]: AirQualitySensor[] };
}

// this entity is for Blinds and Curtains
export interface Shade {
  shadeId: string;
  position: number;
  favourite: number;
}

export interface AwayMode {
  setPoint?: number;
  mode?: 'ON' | 'OFF';
}

export interface Temperature {
  thingId: string;
  temperature: number;
  setPoint: number;
  isScheduled?: boolean;
  overrideEndTimestamp?: number;
  heater: ToggleState;
  schedule?: Schedule;
  away?: AwayMode;
}

export interface Schedule {
  [keys: string]: { setPoint: number };
}

export interface EnergyUsageInPeriod {
  average: number;
  total: number;
  usage: number;
  data: number[];
}

export interface EnergyUsage {
  energyUseToday: number;
  weekly: EnergyUsageInPeriod;
  monthly: EnergyUsageInPeriod;
  yearly: EnergyUsageInPeriod;
}
